'use client';

import { FC, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
/* eslint-disable @next/next/no-img-element */
import styles from './AmenityRow.module.scss';
export interface AmenityItem {
  id: number | string;
  name: string;
  url?: string | null;
}
export interface AmenityRowProps {
  amenities: AmenityItem[];
  maxVisible?: number;
  iconSize?: number;
  className?: string;
}
const AmenityRow: FC<AmenityRowProps> = ({
  amenities,
  maxVisible = 4,
  iconSize = 18,
  className
}) => {
  const withIcons = amenities.filter(a => !!a.url);
  const visible = withIcons.slice(0, maxVisible);
  const hidden = withIcons.slice(maxVisible);
  const [tooltipPos, setTooltipPos] = useState<{
    top: number;
    left: number;
  } | null>(null);
  const moreRef = useRef<HTMLSpanElement>(null);
  const showTooltip = () => {
    if (!moreRef.current) return;
    const rect = moreRef.current.getBoundingClientRect();
    setTooltipPos({
      top: rect.top + window.scrollY,
      left: rect.left + rect.width / 2 + window.scrollX
    });
  };
  const hideTooltip = () => setTooltipPos(null);
  if (visible.length === 0) return null;
  return <div className={`${styles.amenities} ${className || ''}`} data-sentry-component="AmenityRow" data-sentry-source-file="AmenityRow.tsx">
            {visible.map(amenity => <span key={amenity.id} className={styles.amenityIcon} title={amenity.name}>
                        <img src={amenity.url!} alt={amenity.name} width={iconSize} height={iconSize} className={styles.amenityImg} />
                    </span>)}
            {hidden.length > 0 && <span ref={moreRef} className={styles.amenityMore} onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
                    +{hidden.length}
                </span>}
            {tooltipPos && createPortal(<span className={styles.tooltip} style={{
      top: tooltipPos.top,
      left: tooltipPos.left
    }}>
                    {hidden.map(a => a.name).join(', ')}
                </span>, document.body)}
        </div>;
};
export default AmenityRow;